const productFormBtnToolbar = document.querySelector('#AddProductForm_Form .btn-toolbar');

if (productFormBtnToolbar) {
	const cartButton = document.createElement('a');
	const linkText = document.createTextNode('View Cart');
	cartButton.appendChild(linkText);
	cartButton.href = "/cart";
	cartButton.classList.add('cart-button');
	productFormBtnToolbar.appendChild(cartButton);
}